import { render } from "./ParametersCard.vue?vue&type=template&id=d8b1b0ec&scoped=true"
import script from "./ParametersCard.vue?vue&type=script&lang=js"
export * from "./ParametersCard.vue?vue&type=script&lang=js"

import "./ParametersCard.vue?vue&type=style&index=0&id=d8b1b0ec&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8b1b0ec"]])

export default __exports__